var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInteger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m502 146.62h-71.84v-36.87h15.76c5.523 0 10-4.478 10-10v-40c0-5.522-4.477-10-10-10h-91.51c-5.523 0-10 4.478-10 10v40c0 5.522 4.477 10 10 10h15.75v36.87h-360.16c-5.523 0-10 4.478-10 10v198.76c0 5.522 4.477 10 10 10h229c5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10h-219v-178.76h350.16v178.76h-41.16c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10h41.16v36.87h-15.75c-5.523 0-10 4.478-10 10v40c0 5.522 4.477 10 10 10h91.51c5.523 0 10-4.478 10-10v-40c0-5.522-4.477-10-10-10h-15.76v-36.87h71.84c5.523 0 10-4.478 10-10v-198.76c0-5.522-4.477-10-10-10zm-66.08 275.63v20h-71.51v-20h15.75c5.523 0 10-4.478 10-10v-312.5c0-5.522-4.477-10-10-10h-15.75v-20h71.51v20h-15.76c-5.523 0-10 4.478-10 10v312.5c0 5.522 4.477 10 10 10zm56.08-76.87h-61.84v-178.76h61.84z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 355.38,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110 312.786c5.523 0 10-4.478 10-10v-93.572c0-5.522-4.477-10-10-10h-20c-5.523 0-10 4.478-10 10s4.477 10 10 10h10v83.572c0 5.523 4.477 10 10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190 312.786c5.523 0 10-4.478 10-10v-93.572c0-5.522-4.477-10-10-10h-20c-5.523 0-10 4.478-10 10s4.477 10 10 10h10v83.572c0 5.523 4.477 10 10 10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInteger);
export default __webpack_public_path__ + "static/media/icon-integer.06fb03b2d1b87aef7be83faeeadf62b4.svg";
export { ForwardRef as ReactComponent };